/**
 * Centralized Team Logos Configuration
 *
 * This file contains all team logo URLs for consistent display across the application.
 * Import this wherever team logos are needed: import { TEAM_LOGOS, getTeamLogo } from '../utils/teamLogos';
 */

// Team logo URLs using ESPN's CDN
export const TEAM_LOGOS = {
  // NFL Teams
  'Kansas City Chiefs': 'https://a.espncdn.com/i/teamlogos/nfl/500/kc.png',
  'Buffalo Bills': 'https://a.espncdn.com/i/teamlogos/nfl/500/buf.png',
  'San Francisco 49ers': 'https://a.espncdn.com/i/teamlogos/nfl/500/sf.png',
  'Dallas Cowboys': 'https://a.espncdn.com/i/teamlogos/nfl/500/dal.png',
  'Philadelphia Eagles': 'https://a.espncdn.com/i/teamlogos/nfl/500/phi.png',
  'Miami Dolphins': 'https://a.espncdn.com/i/teamlogos/nfl/500/mia.png',
  'Baltimore Ravens': 'https://a.espncdn.com/i/teamlogos/nfl/500/bal.png',
  'Cincinnati Bengals': 'https://a.espncdn.com/i/teamlogos/nfl/500/cin.png',
  'Green Bay Packers': 'https://a.espncdn.com/i/teamlogos/nfl/500/gb.png',
  'Detroit Lions': 'https://a.espncdn.com/i/teamlogos/nfl/500/det.png',
  'Los Angeles Rams': 'https://a.espncdn.com/i/teamlogos/nfl/500/lar.png',
  'Seattle Seahawks': 'https://a.espncdn.com/i/teamlogos/nfl/500/sea.png',
  'New York Jets': 'https://a.espncdn.com/i/teamlogos/nfl/500/nyj.png',
  'New York Giants': 'https://a.espncdn.com/i/teamlogos/nfl/500/nyg.png',
  'Pittsburgh Steelers': 'https://a.espncdn.com/i/teamlogos/nfl/500/pit.png',
  'Cleveland Browns': 'https://a.espncdn.com/i/teamlogos/nfl/500/cle.png',
  'Los Angeles Chargers': 'https://a.espncdn.com/i/teamlogos/nfl/500/lac.png',
  'Las Vegas Raiders': 'https://a.espncdn.com/i/teamlogos/nfl/500/lv.png',
  'Minnesota Vikings': 'https://a.espncdn.com/i/teamlogos/nfl/500/min.png',
  'Jacksonville Jaguars': 'https://a.espncdn.com/i/teamlogos/nfl/500/jax.png',
  'Tampa Bay Buccaneers': 'https://a.espncdn.com/i/teamlogos/nfl/500/tb.png',
  'Atlanta Falcons': 'https://a.espncdn.com/i/teamlogos/nfl/500/atl.png',
  'New Orleans Saints': 'https://a.espncdn.com/i/teamlogos/nfl/500/no.png',
  'Carolina Panthers': 'https://a.espncdn.com/i/teamlogos/nfl/500/car.png',
  'Indianapolis Colts': 'https://a.espncdn.com/i/teamlogos/nfl/500/ind.png',
  'Tennessee Titans': 'https://a.espncdn.com/i/teamlogos/nfl/500/ten.png',
  'Houston Texans': 'https://a.espncdn.com/i/teamlogos/nfl/500/hou.png',
  'Denver Broncos': 'https://a.espncdn.com/i/teamlogos/nfl/500/den.png',
  'Arizona Cardinals': 'https://a.espncdn.com/i/teamlogos/nfl/500/ari.png',
  'Washington Commanders': 'https://a.espncdn.com/i/teamlogos/nfl/500/wsh.png',
  'New England Patriots': 'https://a.espncdn.com/i/teamlogos/nfl/500/ne.png',
  'Chicago Bears': 'https://a.espncdn.com/i/teamlogos/nfl/500/chi.png',

  // NBA Teams
  'Los Angeles Lakers': 'https://a.espncdn.com/i/teamlogos/nba/500/lal.png',
  'Boston Celtics': 'https://a.espncdn.com/i/teamlogos/nba/500/bos.png',
  'Golden State Warriors': 'https://a.espncdn.com/i/teamlogos/nba/500/gs.png',
  'Phoenix Suns': 'https://a.espncdn.com/i/teamlogos/nba/500/phx.png',
  'Miami Heat': 'https://a.espncdn.com/i/teamlogos/nba/500/mia.png',
  'Milwaukee Bucks': 'https://a.espncdn.com/i/teamlogos/nba/500/mil.png',
  'Brooklyn Nets': 'https://a.espncdn.com/i/teamlogos/nba/500/bkn.png',
  'Philadelphia 76ers': 'https://a.espncdn.com/i/teamlogos/nba/500/phi.png',
  'Denver Nuggets': 'https://a.espncdn.com/i/teamlogos/nba/500/den.png',
  'Dallas Mavericks': 'https://a.espncdn.com/i/teamlogos/nba/500/dal.png',
  'Memphis Grizzlies': 'https://a.espncdn.com/i/teamlogos/nba/500/mem.png',
  'Cleveland Cavaliers': 'https://a.espncdn.com/i/teamlogos/nba/500/cle.png',
  'New York Knicks': 'https://a.espncdn.com/i/teamlogos/nba/500/ny.png',
  'Sacramento Kings': 'https://a.espncdn.com/i/teamlogos/nba/500/sac.png',
  'Los Angeles Clippers': 'https://a.espncdn.com/i/teamlogos/nba/500/lac.png',
  'Minnesota Timberwolves': 'https://a.espncdn.com/i/teamlogos/nba/500/min.png',
  'New Orleans Pelicans': 'https://a.espncdn.com/i/teamlogos/nba/500/no.png',
  'Atlanta Hawks': 'https://a.espncdn.com/i/teamlogos/nba/500/atl.png',
  'Chicago Bulls': 'https://a.espncdn.com/i/teamlogos/nba/500/chi.png',
  'Portland Trail Blazers': 'https://a.espncdn.com/i/teamlogos/nba/500/por.png',
  'Utah Jazz': 'https://a.espncdn.com/i/teamlogos/nba/500/utah.png',
  'Toronto Raptors': 'https://a.espncdn.com/i/teamlogos/nba/500/tor.png',
  'Indiana Pacers': 'https://a.espncdn.com/i/teamlogos/nba/500/ind.png',
  'Washington Wizards': 'https://a.espncdn.com/i/teamlogos/nba/500/wsh.png',
  'Charlotte Hornets': 'https://a.espncdn.com/i/teamlogos/nba/500/cha.png',
  'San Antonio Spurs': 'https://a.espncdn.com/i/teamlogos/nba/500/sa.png',
  'Oklahoma City Thunder': 'https://a.espncdn.com/i/teamlogos/nba/500/okc.png',
  'Houston Rockets': 'https://a.espncdn.com/i/teamlogos/nba/500/hou.png',
  'Orlando Magic': 'https://a.espncdn.com/i/teamlogos/nba/500/orl.png',
  'Detroit Pistons': 'https://a.espncdn.com/i/teamlogos/nba/500/det.png',

  // NHL Teams
  'Boston Bruins': 'https://a.espncdn.com/i/teamlogos/nhl/500/bos.png',
  'New York Rangers': 'https://a.espncdn.com/i/teamlogos/nhl/500/nyr.png',
  'Toronto Maple Leafs': 'https://a.espncdn.com/i/teamlogos/nhl/500/tor.png',
  'Montreal Canadiens': 'https://a.espncdn.com/i/teamlogos/nhl/500/mtl.png',
  'Tampa Bay Lightning': 'https://a.espncdn.com/i/teamlogos/nhl/500/tb.png',
  'Colorado Avalanche': 'https://a.espncdn.com/i/teamlogos/nhl/500/col.png',
  'Edmonton Oilers': 'https://a.espncdn.com/i/teamlogos/nhl/500/edm.png',
  'Vegas Golden Knights': 'https://a.espncdn.com/i/teamlogos/nhl/500/vgk.png',
  'Carolina Hurricanes': 'https://a.espncdn.com/i/teamlogos/nhl/500/car.png',
  'New Jersey Devils': 'https://a.espncdn.com/i/teamlogos/nhl/500/nj.png',
  'Dallas Stars': 'https://a.espncdn.com/i/teamlogos/nhl/500/dal.png',
  'Seattle Kraken': 'https://a.espncdn.com/i/teamlogos/nhl/500/sea.png',
  'Los Angeles Kings': 'https://a.espncdn.com/i/teamlogos/nhl/500/la.png',
  'Winnipeg Jets': 'https://a.espncdn.com/i/teamlogos/nhl/500/wpg.png',
  'Florida Panthers': 'https://a.espncdn.com/i/teamlogos/nhl/500/fla.png',
  'Minnesota Wild': 'https://a.espncdn.com/i/teamlogos/nhl/500/min.png',
  'Calgary Flames': 'https://a.espncdn.com/i/teamlogos/nhl/500/cgy.png',
  'Pittsburgh Penguins': 'https://a.espncdn.com/i/teamlogos/nhl/500/pit.png',
  'Nashville Predators': 'https://a.espncdn.com/i/teamlogos/nhl/500/nsh.png',
  'Vancouver Canucks': 'https://a.espncdn.com/i/teamlogos/nhl/500/van.png',
  'St. Louis Blues': 'https://a.espncdn.com/i/teamlogos/nhl/500/stl.png',
  'New York Islanders': 'https://a.espncdn.com/i/teamlogos/nhl/500/nyi.png',
  'Washington Capitals': 'https://a.espncdn.com/i/teamlogos/nhl/500/wsh.png',
  'Buffalo Sabres': 'https://a.espncdn.com/i/teamlogos/nhl/500/buf.png',
  'Detroit Red Wings': 'https://a.espncdn.com/i/teamlogos/nhl/500/det.png',
  'Ottawa Senators': 'https://a.espncdn.com/i/teamlogos/nhl/500/ott.png',
  'Philadelphia Flyers': 'https://a.espncdn.com/i/teamlogos/nhl/500/phi.png',
  'Arizona Coyotes': 'https://a.espncdn.com/i/teamlogos/nhl/500/ari.png',
  'Utah Hockey Club': 'https://a.espncdn.com/i/teamlogos/nhl/500/utah.png',
  'San Jose Sharks': 'https://a.espncdn.com/i/teamlogos/nhl/500/sj.png',
  'Anaheim Ducks': 'https://a.espncdn.com/i/teamlogos/nhl/500/ana.png',
  'Chicago Blackhawks': 'https://a.espncdn.com/i/teamlogos/nhl/500/chi.png',
  'Columbus Blue Jackets': 'https://a.espncdn.com/i/teamlogos/nhl/500/cbj.png',

  // MLB Teams
  'New York Yankees': 'https://a.espncdn.com/i/teamlogos/mlb/500/nyy.png',
  'Boston Red Sox': 'https://a.espncdn.com/i/teamlogos/mlb/500/bos.png',
  'Los Angeles Dodgers': 'https://a.espncdn.com/i/teamlogos/mlb/500/lad.png',
  'San Francisco Giants': 'https://a.espncdn.com/i/teamlogos/mlb/500/sf.png',
  'Houston Astros': 'https://a.espncdn.com/i/teamlogos/mlb/500/hou.png',
  'Atlanta Braves': 'https://a.espncdn.com/i/teamlogos/mlb/500/atl.png',
  'New York Mets': 'https://a.espncdn.com/i/teamlogos/mlb/500/nym.png',
  'Philadelphia Phillies': 'https://a.espncdn.com/i/teamlogos/mlb/500/phi.png',
  'San Diego Padres': 'https://a.espncdn.com/i/teamlogos/mlb/500/sd.png',
  'Toronto Blue Jays': 'https://a.espncdn.com/i/teamlogos/mlb/500/tor.png',
  'St. Louis Cardinals': 'https://a.espncdn.com/i/teamlogos/mlb/500/stl.png',
  'Milwaukee Brewers': 'https://a.espncdn.com/i/teamlogos/mlb/500/mil.png',
  'Tampa Bay Rays': 'https://a.espncdn.com/i/teamlogos/mlb/500/tb.png',
  'Seattle Mariners': 'https://a.espncdn.com/i/teamlogos/mlb/500/sea.png',
  'Cleveland Guardians': 'https://a.espncdn.com/i/teamlogos/mlb/500/cle.png',
  'Minnesota Twins': 'https://a.espncdn.com/i/teamlogos/mlb/500/min.png',
  'Chicago White Sox': 'https://a.espncdn.com/i/teamlogos/mlb/500/chw.png',
  'Chicago Cubs': 'https://a.espncdn.com/i/teamlogos/mlb/500/chc.png',
  'Los Angeles Angels': 'https://a.espncdn.com/i/teamlogos/mlb/500/laa.png',
  'Texas Rangers': 'https://a.espncdn.com/i/teamlogos/mlb/500/tex.png',
  'Arizona Diamondbacks': 'https://a.espncdn.com/i/teamlogos/mlb/500/ari.png',
  'Baltimore Orioles': 'https://a.espncdn.com/i/teamlogos/mlb/500/bal.png',
  'Cincinnati Reds': 'https://a.espncdn.com/i/teamlogos/mlb/500/cin.png',
  'Colorado Rockies': 'https://a.espncdn.com/i/teamlogos/mlb/500/col.png',
  'Detroit Tigers': 'https://a.espncdn.com/i/teamlogos/mlb/500/det.png',
  'Kansas City Royals': 'https://a.espncdn.com/i/teamlogos/mlb/500/kc.png',
  'Miami Marlins': 'https://a.espncdn.com/i/teamlogos/mlb/500/mia.png',
  'Oakland Athletics': 'https://a.espncdn.com/i/teamlogos/mlb/500/oak.png',
  'Pittsburgh Pirates': 'https://a.espncdn.com/i/teamlogos/mlb/500/pit.png',
  'Washington Nationals': 'https://a.espncdn.com/i/teamlogos/mlb/500/wsh.png',

  // AFL Teams (Australian Football League)
  'Adelaide Crows': 'https://a.espncdn.com/i/teamlogos/afl/500/adel.png',
  'Brisbane Lions': 'https://a.espncdn.com/i/teamlogos/afl/500/bris.png',
  'Carlton Blues': 'https://a.espncdn.com/i/teamlogos/afl/500/carl.png',
  'Collingwood Magpies': 'https://a.espncdn.com/i/teamlogos/afl/500/coll.png',
  'Essendon Bombers': 'https://a.espncdn.com/i/teamlogos/afl/500/ess.png',
  'Fremantle Dockers': 'https://a.espncdn.com/i/teamlogos/afl/500/fre.png',
  'Geelong Cats': 'https://a.espncdn.com/i/teamlogos/afl/500/geel.png',
  'Gold Coast Suns': 'https://a.espncdn.com/i/teamlogos/afl/500/gcfc.png',
  'Greater Western Sydney Giants': 'https://a.espncdn.com/i/teamlogos/afl/500/gws.png',
  'GWS Giants': 'https://a.espncdn.com/i/teamlogos/afl/500/gws.png',
  'Hawthorn Hawks': 'https://a.espncdn.com/i/teamlogos/afl/500/haw.png',
  'Melbourne Demons': 'https://a.espncdn.com/i/teamlogos/afl/500/melb.png',
  'North Melbourne Kangaroos': 'https://a.espncdn.com/i/teamlogos/afl/500/nmfc.png',
  'Port Adelaide Power': 'https://a.espncdn.com/i/teamlogos/afl/500/port.png',
  'Richmond Tigers': 'https://a.espncdn.com/i/teamlogos/afl/500/rich.png',
  'St Kilda Saints': 'https://a.espncdn.com/i/teamlogos/afl/500/stk.png',
  'Sydney Swans': 'https://a.espncdn.com/i/teamlogos/afl/500/syd.png',
  'West Coast Eagles': 'https://a.espncdn.com/i/teamlogos/afl/500/wce.png',
  'Western Bulldogs': 'https://a.espncdn.com/i/teamlogos/afl/500/wb.png',

  // NRL Teams (National Rugby League)
  'Brisbane Broncos': 'https://a.espncdn.com/i/teamlogos/rugby/500/bris.png',
  'Canberra Raiders': 'https://a.espncdn.com/i/teamlogos/rugby/500/can.png',
  'Canterbury Bulldogs': 'https://a.espncdn.com/i/teamlogos/rugby/500/cbull.png',
  'Cronulla Sharks': 'https://a.espncdn.com/i/teamlogos/rugby/500/cro.png',
  'Gold Coast Titans': 'https://a.espncdn.com/i/teamlogos/rugby/500/gc.png',
  'Manly Sea Eagles': 'https://a.espncdn.com/i/teamlogos/rugby/500/man.png',
  'Melbourne Storm': 'https://a.espncdn.com/i/teamlogos/rugby/500/mel.png',
  'Newcastle Knights': 'https://a.espncdn.com/i/teamlogos/rugby/500/new.png',
  'North Queensland Cowboys': 'https://a.espncdn.com/i/teamlogos/rugby/500/nqc.png',
  'Parramatta Eels': 'https://a.espncdn.com/i/teamlogos/rugby/500/par.png',
  'Penrith Panthers': 'https://a.espncdn.com/i/teamlogos/rugby/500/pen.png',
  'South Sydney Rabbitohs': 'https://a.espncdn.com/i/teamlogos/rugby/500/sou.png',
  'St George Illawarra Dragons': 'https://a.espncdn.com/i/teamlogos/rugby/500/stg.png',
  'Sydney Roosters': 'https://a.espncdn.com/i/teamlogos/rugby/500/syd.png',
  'Wests Tigers': 'https://a.espncdn.com/i/teamlogos/rugby/500/wst.png',
  'New Zealand Warriors': 'https://a.espncdn.com/i/teamlogos/rugby/500/nzw.png',
  'Dolphins': 'https://a.espncdn.com/i/teamlogos/rugby/500/dol.png',

  // Super Rugby Teams
  'Blues': 'https://a.espncdn.com/i/teamlogos/rugby/500/blu.png',
  'Chiefs': 'https://a.espncdn.com/i/teamlogos/rugby/500/chi.png',
  'Crusaders': 'https://a.espncdn.com/i/teamlogos/rugby/500/cru.png',
  'Highlanders': 'https://a.espncdn.com/i/teamlogos/rugby/500/high.png',
  'Hurricanes': 'https://a.espncdn.com/i/teamlogos/rugby/500/hur.png',
  'Brumbies': 'https://a.espncdn.com/i/teamlogos/rugby/500/brum.png',
  'Reds': 'https://a.espncdn.com/i/teamlogos/rugby/500/reds.png',
  'Waratahs': 'https://a.espncdn.com/i/teamlogos/rugby/500/war.png',
  'Western Force': 'https://a.espncdn.com/i/teamlogos/rugby/500/wfor.png',
  'Fijian Drua': 'https://a.espncdn.com/i/teamlogos/rugby/500/fij.png',
  'Moana Pasifika': 'https://a.espncdn.com/i/teamlogos/rugby/500/moa.png',

  // Cricket Teams (International)
  'Australia': 'https://a.espncdn.com/i/teamlogos/cricket/500/aus.png',
  'England': 'https://a.espncdn.com/i/teamlogos/cricket/500/eng.png',
  'India': 'https://a.espncdn.com/i/teamlogos/cricket/500/ind.png',
  'New Zealand': 'https://a.espncdn.com/i/teamlogos/cricket/500/nz.png',
  'Pakistan': 'https://a.espncdn.com/i/teamlogos/cricket/500/pak.png',
  'South Africa': 'https://a.espncdn.com/i/teamlogos/cricket/500/sa.png',
  'West Indies': 'https://a.espncdn.com/i/teamlogos/cricket/500/wi.png',
  'Sri Lanka': 'https://a.espncdn.com/i/teamlogos/cricket/500/sl.png',
  'Bangladesh': 'https://a.espncdn.com/i/teamlogos/cricket/500/ban.png',
  'Afghanistan': 'https://a.espncdn.com/i/teamlogos/cricket/500/afg.png',

  // NCAAF Teams (College Football - Major Programs)
  'Alabama Crimson Tide': 'https://a.espncdn.com/i/teamlogos/ncaa/500/333.png',
  'Ohio State Buckeyes': 'https://a.espncdn.com/i/teamlogos/ncaa/500/194.png',
  'Georgia Bulldogs': 'https://a.espncdn.com/i/teamlogos/ncaa/500/61.png',
  'Michigan Wolverines': 'https://a.espncdn.com/i/teamlogos/ncaa/500/130.png',
  'Texas Longhorns': 'https://a.espncdn.com/i/teamlogos/ncaa/500/251.png',
  'USC Trojans': 'https://a.espncdn.com/i/teamlogos/ncaa/500/30.png',
  'Notre Dame Fighting Irish': 'https://a.espncdn.com/i/teamlogos/ncaa/500/87.png',
  'Clemson Tigers': 'https://a.espncdn.com/i/teamlogos/ncaa/500/228.png',
  'Oklahoma Sooners': 'https://a.espncdn.com/i/teamlogos/ncaa/500/201.png',
  'LSU Tigers': 'https://a.espncdn.com/i/teamlogos/ncaa/500/99.png',
  'Florida State Seminoles': 'https://a.espncdn.com/i/teamlogos/ncaa/500/52.png',
  'Penn State Nittany Lions': 'https://a.espncdn.com/i/teamlogos/ncaa/500/213.png',
  'Oregon Ducks': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2483.png',
  'Tennessee Volunteers': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2633.png',
  'Miami Hurricanes': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2390.png',

  // NCAAB Teams (College Basketball - Major Programs)
  'Duke Blue Devils': 'https://a.espncdn.com/i/teamlogos/ncaa/500/150.png',
  'North Carolina Tar Heels': 'https://a.espncdn.com/i/teamlogos/ncaa/500/153.png',
  'Kentucky Wildcats': 'https://a.espncdn.com/i/teamlogos/ncaa/500/96.png',
  'Kansas Jayhawks': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2305.png',
  'UConn Huskies': 'https://a.espncdn.com/i/teamlogos/ncaa/500/41.png',
  'Gonzaga Bulldogs': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2250.png',
  'Villanova Wildcats': 'https://a.espncdn.com/i/teamlogos/ncaa/500/222.png',
  'UCLA Bruins': 'https://a.espncdn.com/i/teamlogos/ncaa/500/26.png',
  'Arizona Wildcats': 'https://a.espncdn.com/i/teamlogos/ncaa/500/12.png',
  'Houston Cougars': 'https://a.espncdn.com/i/teamlogos/ncaa/500/248.png',
};

/**
 * Get team logo URL by team name
 * @param {string} teamName - The full team name
 * @returns {string|null} - The logo URL or null if not found
 */
export const getTeamLogo = (teamName) => {
  if (!teamName) return null;
  return TEAM_LOGOS[teamName] || null;
};

/**
 * Get team logo URL with fuzzy matching (partial match)
 * @param {string} teamName - The team name or partial name
 * @returns {string|null} - The logo URL or null if not found
 */
export const getTeamLogoFuzzy = (teamName) => {
  if (!teamName) return null;

  // Exact match first
  if (TEAM_LOGOS[teamName]) return TEAM_LOGOS[teamName];

  // Try partial match (team name ends with search term)
  const lowerSearch = teamName.toLowerCase();
  for (const [name, url] of Object.entries(TEAM_LOGOS)) {
    if (name.toLowerCase().includes(lowerSearch) ||
        lowerSearch.includes(name.toLowerCase())) {
      return url;
    }
  }

  return null;
};

/**
 * Check if a team has a logo available
 * @param {string} teamName - The full team name
 * @returns {boolean} - True if logo exists
 */
export const hasTeamLogo = (teamName) => {
  return !!TEAM_LOGOS[teamName];
};

export default TEAM_LOGOS;
